export default __webpack_public_path__ + "buysearchsell/images/box-of-toys.svg";